import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";

import 'react-loading-bar/dist/index.css';
import Footer from "./Footer";
import CustomMap from "./CustomMap";
let config = require('../Config/appConfig.json');

let DOWNLOAD_LINK_ANDROID = config.DOWNLOAD_LINK_ANDROID;
let DOWNLOAD_LINK_IOS = config.DOWNLOAD_LINK_IOS;
const context = "HexaFood.js";
var self = null;
@inject("appStore")
@observer
class HexaFood extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showProgress: false,
            items: [],
            routes: [],
            pathCoordinates: [],
            lat: 22.579217,
            lng: 88.469495,
            description: "",
            stops_array: []
        };
    }
    componentWillMount = () => {
        self = this;

    }
    openDownloadLink = (where_to) => {
        var link_to_open = null;
        if (where_to === "android") {
            link_to_open = DOWNLOAD_LINK_ANDROID;
        } else if (where_to === "iOS") {
            link_to_open = DOWNLOAD_LINK_IOS;
        }

        if (link_to_open === null) {

        } else {
            var win = window.open(link_to_open);

        }
    }
    render() {
        return (

            <div>

                <section style={{ 'marginTop': '75px' }}  >
                    <div style={{ width: '100%' }}>
                        <img src="assets/img/banner/Food.jpg" />
                    </div>
                </section>

                <section className="pt-80 pb-60 section-pattern ov-hidden" id="about_us" >
                    <div className="container" >
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="section-title">
                                    <h3>About Hexa Food</h3>
                                    <h2>Order online from Hexa H2O app</h2>

                                </div>
                                <div className="about-nav-tab">
                                <h4>We always deliver healthy and delicious food</h4><br/>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="mission" role="tabpanel">
                                            <span>Home delivery meal service</span><br></br>
                                            <span>Meals would have a different variety of food to choose from</span><br></br>
                                            <span>Proper food packaging with standard measures.</span><br></br>
                                            <span>Delivery to your doorstep with few clicks</span><br></br>
                                            <span>Meals would be offered at a very reasonable rate</span><br></br><br></br><br></br>

                                        </div>

                                    </div>
                                </div>
                                {/* <span style={{ 'font-size': '25px', 'font-family': 'Times New Roman' }}>Hexa Food's safety Measures</span><br></br><br></br> */}

                                <div className="section-title">
                                    <h3>Hexa Food's Safety Measures</h3>
                                    <h5>Your order is safe at every step.</h5>
                            
                                    <h5>Find out what we are doing to deliver it safely.</h5>

                                </div>
                                {/* <span style={{ 'color': '#ffff00' }} >
                                    <a target="_blank" href="safety/safety">Safety Measures</a>
                                    <a href="javascript:void(0)" class="badge badge-info" onClick={(e) => this.openFoodLink()}>Click here to know more about it.</a>
                                </span> */}
                                <span style={{ 'font-size': '20px', 'color': '#ff0000' }} >

                                    <a target="_blank" href="safety/safety" class="badge badge-info">Click here to know more about it.</a>
                                </span>

                            </div>

                            <div className="col-lg-6 video-area mt-10 mt-lg-0">
                                <img className="card-img-top" src="assets/custom_icons/kitchen1.jpg" />
                            </div>

                            <div className="row align-items-center">
                                <div className="col-lg-12 col-md-12 col-sm-12">

                                
                                <div className="about-nav-tab">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-items"> <a className="nav-link active" data-toggle="tab" href="#mission" role="tab"
                                            aria-selected="true">Available Meals</a> </li>

                                    </ul>

                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="mission" role="tabpanel">

                                            <span>Idli,Alu Paratha.</span>
                                            <span>Chicken/Paneer/Cheese Sandwich.</span><br></br>
                                            <span>Mix Veg,Kashmiri Aludum,Veg Munchurian,Matar Paneer,Paneer Butter Masala.</span><br></br>
                                            <span>Kadai Panner,Chilli Paneer.</span> <br></br><br></br>
                                            <span><u>Veg Thali</u>- Basmati-Rice,Fry,Dal,Paneer Masala,Papad,Salad,Dessert.</span><br></br>


                                            <span><u>Egg Thali</u>- Basmati-Rice,Fry,Dal,Egg(2pc) Curry,Papad,Salad,Dessert.</span><br></br>

                                            <span> <u>Fish Thali</u>- Basmati-Rice,Fry,Dal,Fish(1pc) Curry,Papad,Salad,Dessert.</span> <br></br>

                                            <span><u>Chicken Thali</u>- Basmati-Rice,Fry,Dal,Chicken(2pc) Kosha,Papad,Salad,Dessert.</span><br></br>

                                            <span><u>Mutton Thali</u>- Basmati-Rice,Fry,Dal,Mutton(2pc) Kosha,Papad,Salad,Dessert</span><br></br><br></br>

                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>



                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-6 col-sm-12" style={{ marginBottom: 20 }}>
                                <a href="javascript:void(0)" className="btn-get-the-app hover-box-effect" onClick={(e) => this.openDownloadLink("android")}>
                                    <img src="assets/img/custom_icons/playstore.png" className="svg" style={{ 'width': '30px', 'height': '30px', 'marginRight': '20px' }} alt="" /> Get In Android
                                                    </a>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12" style={{ marginBottom: 20 }}>
                                <a href="javascript:void(0)" className="btn-get-the-app hover-box-effect" onClick={(e) => this.openDownloadLink("iOS")}>
                                    <img src="assets/img/custom_icons/apple_icon.png" className="svg" style={{ 'width': '30px', 'height': '30px', 'marginRight': '20px' }} alt="" /> Get In iOS
                                                    </a>
                            </div>

                        </div>



                    </div>
                </section>

                <section className="pt-50 pb-90 section-pattern">
                    <div className="container">
                        <div className="section-title">
                            <h3>Are you not ordering yet?...</h3>
                            <h2>Find out where we are currently operating. </h2>
                            {/* <p>We basically catter office commute in form of Hexa H2O and aslo school as Hexa Skool.</p> */}
                        </div>
                        <div className="row justify-content-left">

                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div style={{ height: 500, width: '70%' }} >
                                    <CustomMap PathCoordinates={this.state.pathCoordinates} lat={this.state.lat} lng={this.state.lng} />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        );

    }
}
export default withRouter(HexaFood);


// WEBPACK FOOTER //
// ./src/Pages/HexaFood.js